<template>
  <div class="app-reset-password-confirm-password">
    <div class="headline">
      <h4>
        <slot name="headline"></slot>
      </h4>
    </div>
    <div class="subline">
      <slot name="subline"></slot>
    </div>
    <b-form @submit="save">
      <BirthdateInputValidation
        ref="birthDateInput"
        :invalid.sync="birthdateInvalid"
        :date.sync="birthdate"
      >
        <template v-for="slot in possibleChildSlotsFor('Birthdate')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </BirthdateInputValidation>
      <password-with-repeat
        ref="passwordInput"
        :password.sync="newPassword"
        :repeat.sync="newPasswordRepeat"
        :invalid.sync="passwordInvalid"
        :on-return-key="save"
      >
        <template v-for="slot in possibleChildSlotsFor('Repeat')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </password-with-repeat>
      <div class="error-box" v-html="getBackendErrorMessage" v-if="showBackendError">
        <slot name="txtErrorTechnical"></slot>
      </div>
      <MessageModal></MessageModal>

      <Stepper
        class="stepper"
        :show-prev="channel === 'sms'"
        :disabled-next="loading"
        :disabled-prev="loading"
        @next="save"
        @prev="back"
      >
        <template slot="btnNext">
          <slot name="ctaNext"></slot>
        </template>
        <template slot="btnPrev">
          <slot name="ctaPrev"></slot>
        </template>
      </Stepper>
    </b-form>
    <slot name="txtAfter">
    </slot>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import date from '@/mixins/validators/date'
import { BForm } from 'bootstrap-vue'
import isValid from '@/mixins/validators/isValid'
import BirthdateInputValidation from '@/components/forms/LabeledBirthdateInput.vue'
import PasswordWithRepeat from '@/components/generic/PasswordWithRepeat.vue'
import MessageModal from '@/components/generic/MessageView/MessageList.vue'
import beErrors from '@/mixins/beErrors'
import contaoLogin from '@/mixins/contaoLogin'
import validationFlow from '@/mixins/validators/validationFlow'
import Stepper from '@/components/generic/Stepper.vue'

export default {
  name: 'ResetPasswordConfirmationPassword',
  data: function () {
    return {
      brand_: null,
      newPassword: '',
      newPasswordRepeat: '',
      passwordInvalid: false,
      birthdateInvalid: false,
      birthdate: null,
      loading: false,
      showBackendError: false
    }
  },
  mounted () {
    // reset error message from previous transactions
    this.$store.commit('clearMessages', {}, { root: true })
  },
  computed: {
    getBackendErrorMessage: function () {
      return this.beErrorGetLastMessage()
    },
    ...mapGetters('resetPassword', [
      'token'
    ]),
    ...mapGetters('forgotPassword', [
      'msisdn', 'channel'
    ]),
    isIosDevice () {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    }
  },
  created () {
    this.brand_ = this.$store.getters.brand
  },
  components: {
    Stepper,
    MessageModal,
    PasswordWithRepeat,
    BirthdateInputValidation,
    BForm
  },
  mixins: [
    validationMixin,
    isValid,
    beErrors,
    contaoLogin,
    validationFlow,
    date
  ],
  methods: {
    ...mapMutations('forgotPassword', [
      'setView'
    ]),
    selectDate (ctx) {
      if (ctx.selectedDate) {
        this.birthdate = ctx.selectedFormatted
      }
    },
    redirectToSuccessPage () {
      window.location.href = this.successLink
    },
    redirectToSuccessRegistrationPage () {
      window.location.href = this.successRegistrationLink
    },
    back () {
      this.setView('token')
    },
    async save () {
      // ensure live feedback for validation errors
      if (this.$refs.birthDateInput) {
        this.$refs.birthDateInput.vflowForceFeedback()
      }
      if (this.$refs.passwordInput) {
        this.$refs.passwordInput.vflowForceFeedback()
      }

      if (this.token !== null && !this.birthdateInvalid && !this.passwordInvalid) {
        this.loading = true
        const comp = this
        this.resetPassword({
          password: comp.newPassword,
          birthdate: this.birthdate
        }).then((response) => {
          if (response.data && response.data.resetPasswordWithState.contractStatus === 'ACTIVE') {
            // now way, redirect user to fallback (login) page
            comp.loading = false
            if (window.App !== undefined && window.App.reset !== undefined) {
              if (this.isIosDevice) {
                window.webkit.messageHandlers.reset.postMessage('resetPassword')
              } else {
                window.App.reset('resetPassword')
              }
            } else {
              comp.redirectToSuccessPage()
            }
          } else if (response.data && response.data.resetPasswordWithState.contractStatus === 'CREATED') {
            comp.loading = false
            if (window.App !== undefined && window.App.reset !== undefined) {
              if (this.isIosDevice) {
                window.webkit.messageHandlers.reset.postMessage('resetPassword')
              } else {
                window.App.reset('resetPassword')
              }
            } else {
              comp.redirectToSuccessRegistrationPage()
            }
          } else {
            comp.loading = false
          }
        }, () => {
          comp.loading = false
          if (this.beHasMessages()) {
            comp.showBackendError = true
          }
        })
      } else {
        // ensure live feedback for validation errors
        this.vFlowGetFirstErrorElementName().then(function (result) {
          const data = {
            type: 'validation',
            message: 'required field missing',
            location: result + ' - unknown'
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
      }
    },
    ...mapActions('resetPassword', [
      'resetPassword'
    ]),
    ...mapMutations('resetPassword', [
      'finalizeProcess'
    ])
  },
  props: {
    successLink: {
      type: String,
      default: 'login'
    },
    successRegistrationLink: {
      type: String,
      default: '#'
    }
  }
}
</script>
